export interface Product {
    id?: number;
    productId?: string;
    productCode: string;
    productName: string;
    segment: SegmentType
    category: string;
    subCategory: string[];
    image: string[];
    price: number;
    tags: string[];
    occasion: string;
    vendor: string;
    certification: string;
    gender: string;
    priceBreakup: {
      metal: number;
      discountedDiamondPrice: number;
      actualDiamondPrice: number;
      discountMakingCharges: number;
      makingCharges: number;
      gst: number;
      gstPercent: number;
      total: number;
      discountTotal: number;
    };
    discountPercent: string;
    metalDetails: {
      metalName: string;
      purity: number;
      metalWt?: number;
    };
    diamondDetails: {
      totalNumberOfDiamonds: number;
      totalWt: number;
      diamondEntries: { diamondSize: string; diamondCount: number; totalwt: number }[];
      solitaireEntries: { solitaireSize: number; solitaireCount: number }[];      
      diamonds: {
        clarity: string;
        color: string;
        numberOfDiamonds: number;
        settingType: string;
        shape: string;
        diamondWtApprox: number;
        additionalCharges: number;
      };
      solitaire: { 
        stClarity: string;
        stColor: string;
        numberOfStDiamonds: number;
        stSettingType: string;
        stShape: string;
        stDiamondWt: number;
        availableSizes: number[];
      };
    };
    productSummary: {
      width: string;
      grossWt: string;
    };
    productDescription: string;
    makingPercentage?: number;
    note: string;
    isCatalog: boolean;
    isInventory: boolean;
  }

  export enum SegmentType {
    GOLD_JEWELLERY = "GOLD_JEWELLERY",
    SILVER_JEWELLERY = "SILVER_JEWELLERY",
    DIAMOND_JEWELLERY = "DIAMOND_JEWELLERY",
    GEMS_AND_STONES_JEWELLERY = "GEMS_AND_STONES_JEWELLERY",
  }
  
  


  